module.exports = "<div class=\"page-body\">\n  <div layout-fill layout=\"column\" layout-align=\"center center\">\n    <img src=\"assets/img/logo-white-solid.png\">\n    <h2>Morphii Feedback and Support</h2>\n    <div layout=\"row\" layout-align=\"center center\">\n      <md-card>\n        <md-card-content class=\"push-bottom-none push-top-none\">\n          <p>We are here to help. If you have any questions or feedback please send email to <a href=\"mailto:info@morphii.com\">support@morphii.com</a>.</p>\n        </md-card-content>\n      </md-card>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 240
// module chunks = 2